module.exports = __webpack_public_path__ + "img/mandiri.9d5cf363.svg";